import './DoItSh.css';
import htmlContent from './DoItSh.html?raw';

class DoItSh {
  constructor(container) {
    this.container = container;
  }

  async render() {
    try {
      this.container.innerHTML = htmlContent;

      // Add a subtle load animation
      this.container.style.opacity = '0';
      this.container.style.transform = 'translateY(10px)';
      this.container.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';

      setTimeout(() => {
        this.container.style.opacity = '1';
        this.container.style.transform = 'translateY(0)';
      }, 50);

    } catch (error) {
      console.error('Error rendering DoItSh component:', error);
      this.container.innerHTML = '<p>Error loading content. Please refresh the page.</p>';
    }
  }
}

export default DoItSh;
